import React from "react";

/**
 * Icons
 */
import FlightLand from "@mui/icons-material/FlightLand";
import FlightTakeoff from "@mui/icons-material/FlightTakeoff";

import {
  Box,
  Button,
  Slide,
  Typography,
  SxProps,
  useTheme,
} from "@mui/material";

import { IFlightDates } from "redux/searchForm";
import { formatDateShort, useConfig } from "@thekilroygroup/shared-ui";

interface IProps {
  isReturn: boolean;
  value: IFlightDates;
  closeDrawer: () => void;
}
export function DatePickerDrawer(props: IProps) {
  const { isReturn, value, closeDrawer } = props;
  const t = useTheme();
  const { locale } = useConfig();

  const { bottomDrawer, text, confirmButton } = sxStyles;

  return (
    <Slide
      direction="up"
      in={value.departureDate !== null}
      mountOnEnter
      unmountOnExit
    >
      <Box
        sx={{
          ...bottomDrawer,
          boxShadow: t.shadows[19],
          zIndex: t.zIndex.appBar,
        }}
      >
        <Typography variant="h5" color="white" sx={text}>
          <FlightTakeoff />
          {value.departureDate !== null &&
            formatDateShort(value.departureDate, locale)}
        </Typography>
        {isReturn && (
          <Typography variant="h5" color="white" sx={text}>
            <FlightLand />
            {value.returnDate !== null ? (
              formatDateShort(value.returnDate, locale)
            ) : (
              <>-</>
            )}
          </Typography>
        )}

        <Button
          sx={confirmButton}
          onClick={() => closeDrawer()}
          variant="text"
          size="medium"
        >
          Ok
        </Button>
      </Box>
    </Slide>
  );
}

const sxStyles: { [key: string]: SxProps } = {
  bottomDrawer: {
    backgroundColor: "primary.main",
    p: 2,
    position: "absolute",
    left: 0,
    bottom: 0,
    right: 0,
  },
  text: {
    display: "flex",
    alignItems: "center",
    height: 32,
    color: "white.main",
    "& .MuiSvgIcon-root": {
      mr: 1,
    },
  },
  confirmButton: {
    position: "absolute",
    right: 0,
    bottom: 8,
    color: "white.main",
  },
};
